import React, { useState } from 'react';
import './Search.css';
import { FaSearch } from "react-icons/fa";

// تم التأكد من أن props المستقبلة هي onSearch (دالة) و jobsNumber (رقم)
function Search({ onSearch, jobsNumber }) {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        // التأكد من أن onSearch هي دالة قبل استدعائها
        if (typeof onSearch === 'function') {
            onSearch(value);
        }
    };

    return (
        <div>
            <div className='top'>
                <div className='container'>
                    <div className='search-container'>
                        <div className='search-icon'>
                            <FaSearch />
                        </div>
                        <input
                            className='search-input'
                            type='search'
                            placeholder='ابحث عن وظيفتك'
                            value={searchTerm}
                            onChange={handleSearchChange}
                            aria-label="البحث عن الوظائف"
                            autoComplete="off"
                        />
                    </div>
                    <div className='jobs-text'>
                        <span>وظائف متاحة</span>
                        {/* عرض الرقم القادم من jobsNumber. إذا لم يكن موجوداً، يتم عرض '...' */}
                        <span className='available-jobs-num'>{typeof jobsNumber === 'number' ? jobsNumber : '...'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Search;